<template lang="pug">
.sec
  //- 標題區
  .pageHeader(v-if="pageData !== null")
    //- 頁面名稱
    .pageName {{ pageData.title }}
    //- TAB
    .pageTabBlock
      router-link.pageTab(
        v-for="item in pageData.type.section.tabs"
        :key="item.id"
        :to="`/section/${$route.params.pageid}/category/${item.id}`" :class="{active: Number($route.params.categoryid) === Number(item.id)}") {{ item.name }}
    .pageSelectBlock(tabindex="0" @blur="select_on = false")
      .pageSelect(@click="select_on = !select_on") {{ currentTab }}
        .tri(:class="{selected: select_on === true}")
      .pageTabOptionBlock(:class="{active: select_on === true}")
        router-link.pageTabOption(
          v-for="item in pageData.type.section.tabs"
          :key="item.id"
          @click.native="select_on = false"
          :to="'/section/' + $route.params.pageid + '/category/' + item.id"
          :class="{active: Number($route.params.categoryid) === Number(item.id)}"
        ) {{ item.name }}
  //- 內容區
  .secBottom
    //- 卡片本體
    router-link.secCard(
      v-for="item in postData"
      :key="item.id || newsDataNumber"
      :to="getPostLink(item)"
    )
      ImgLoader.secPic(
        :img="item.cover_photo"
        :style="{'--bgPos': 'center'}"
      )
      .secTextBox
        .secDate {{ card_date(item) }}
        .secTitle {{ item.title }}
        .secSubTitle ➤ {{ card_pro(item) }}
  //- 頁碼
  .pageBlock
    .prev(
      v-if="Number(p) > 1"
      @click="prev()"
    )
    .cur_page {{ p > 10 ? p : '0' + p }}
    .line /
    .total {{ totalPage > 10 ? totalPage : '0' + totalPage }}
    .next(
      v-if="Number(p) < totalPage"
      @click="next()"
    )
  //- router-view(:news-array="NewsArray" :search-input="searchInput")
</template>

<script>
import { warn } from '@/utils/msg'
import { fetchArticleList } from '@/api/client/Articles'
export default {
  data() {
    return {
      select_on: false,
      searchInput: null,
      pageData: {
        title: '成果專區',
        type: {
          section: {
            tabs: [
              { id: 122, name: "活動成果" },
              { id: 124, name: "研習成果" },
              { id: 125, name: "參訪成果" },
              { id: 126, name: "影音成果" },
              { id: 127, name: "出版成果" },
              { id: 123, name: "其他成果" },

            ]
          }
        }
      },
      postData: null,
      last_page: 1,
      page: [
        {
          id: 1,
          name: '最新消息'
        },
        {
          id: 2,
          name: '成果專區'
        },
      ],
      category: [
        {
          id: 1,
          title: ['重要公告', '活動訊息'],
        },
        {
          id: 2,
          title: ['工作坊成果', '研習成果', '參訪成果', '活動成果', '影音成果'],
        },
      ],
      NewsArray: [],
    }
  },
  computed: {
    //頁碼
    totalPage() {
      if (Number(this.$route.params.categoryid) === 0) {
        return Math.ceil(Number(this.NewsArray.length) / 12);
      } else {
        return this.last_page;
      }
    },
    currentTab() {
      const target = this.pageData.type.section.tabs.find(item => item.id == this.$route.params.categoryid)
      if (target) return target.name
      warn('找不到資料')
      this.$router.push({ name: 'NotFound' })
      return null
    },
    //現在第幾頁
    p() {
      if (this.$route.query.p === undefined) { return 1 }
      else {
        return this.$route.query.p
      }
    },
  },
  async created() {
    const categoryId = this.$route.params.categoryid
    this.getTopArticles(categoryId, this.p);
  },
  methods: {
    getPostLink(item) {
      const { id: postid, article_db_id: dbId } = item
      const { categoryid } = this.$route.params
      return {
        name: 'Post',
        params: {
          categoryid, postid
        },
        query: {
          dbId
        }
      }
    },
    async getTopArticles(categoryId, page) {
      const MAX_AMOUNT = 15
      const res = await fetchArticleList({ categoryId, page })
      const { total_num, data } = res
      let lastPage = Math.ceil(total_num / MAX_AMOUNT)
      lastPage = lastPage === 0 ? 1 : lastPage
      this.postData = data
      this.last_page = lastPage
    },

    // 卡片時間
    card_date(item) {
      if (item.publish_time) {
        return item.publish_time.slice(0, 10);
      } else {
        return item.date;
      };
    },
    // 卡片計畫名稱
    card_pro(item) {
      if (item.author) {
        return item.author.name;
      } else {
        return item.pro;
      }
    },
    prev() {
      if (this.p < 1) {
        return null;
      } else {
        let next_page = Math.ceil(Number(this.p) - 1);
        this.$router.push({ query: { p: next_page } });
        this.getTopArticles(this.$route.params.categoryid, this.p);
      }
    },
    next() {
      let page = Number(this.p);
      if (page >= Number(this.totalPage)) {
        return null;
      } else if (page === 1 && page < this.totalPage) {
        this.$router.push({ query: { p: 2 } })
        this.getTopArticles(this.$route.params.categoryid, 2);
      } else {
        this.$router.push({ query: { p: this.$route.query.p += 1 } });
        this.getTopArticles(this.$route.params.categoryid, this.p);
      }
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
*
  // +bb
.sec
  width: 80%
  box-sizing: border-box
  margin-top: 10px
  margin-left: 10%
  // padding: 0 0 400px 0
  +pad
    width: 95%
    margin-left: 2.5%
    // min-height: 93vw
  +phone
    +ie
      min-height: 200vw

  //內容區容器
  .secBottom
    width: 100%
    // height: 40vw
    // margin-left: 10%
    margin-top: 1%
    box-sizing: border-box
    // +bb
    +flexrow
    flex-wrap: wrap
    +smallcom
      // height: 50vw
    +pad
      margin-top: 2%
      // height: auto
    +phone
      +flexcolumn
      width: 100%
      // margin-left: 2.5%
      margin-top: 20px
      flex-wrap: initial
      // height: auto
    +phone5
      // min-height: 135vw

    //卡片本體
    .secCard
      width: 24.25%
      margin-right: 1%
      margin-bottom: 4%
      position: relative


      +pad
        width: 31.8%
        margin-right: 2.3%

      +phone
        width: 100%
        +flexrow
        border-bottom: solid 1px #878787
        padding: 0 0 10px 0
        margin-right: 0
        margin-bottom: 10px
      &:nth-child(4n)
        margin-right: 0
        +pad
          margin-right: 2.3%
      &:nth-child(3n)
        +pad
          margin-right: 0

      .secPic
        position: relative
        width: 100%
        height: 18vw
        +pad
          width: 100%
          height: 26vw
        +phone
          width: 40%
          height: 32vw
          margin-left: 0
          margin-right: 10px
          min-width: 127.3px
          min-height: 107.19px
      .secTextBox
        width: 100%
        +phone
          width: calc(60% - 10px)
        .secDate
          width: 85%
          font-size: 13px
          margin-top: 2%
          color: #878787
          +pad
            width: 90%
          +phone
            width: 100%
            margin-top: 0

        .secSubTitle
          width: 85%
          font-size: 13px
          margin-top: 1%
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          color: #878787
          +phone
            margin-top: 5%
            -webkit-line-clamp: 1
        .secTitle
          // width: 85%
          font-size: 15px
          margin-top: 2%
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          font-weight: 800

          +pad
            // width: 90%
            // font-size: 1.8vw
            // letter-spacing: 0.1v
            // margin-left: 5%
            // margin-right: 5%
          +phone
            // width: 90%
            -webkit-line-clamp: 3
            line-height: 28px
            // font-size: 4vw
            // line-height: 7vw
            margin-top: 3%
          @media all and (max-width: 423px)
            -webkit-line-clamp: 2

    .secPageList
      width: 100%
      height: 6%
      +flexrow
      justify-content: center
      // +bb
      +phone
        height: 6vw
        margin-top: 10%
      .secPrev
        width: 1%
        height: 40%
        background: url('../../assets/slide/prev.png')
        +bgcon
        // +bb
        background-position: 0 0
        background-size: 100% auto
        margin-right: 0.5vw
        opacity: 0.5
        margin-top: 0.1%
        cursor: pointer
        +pad
          width: 3%
          height: 100%
          margin-right: 1.8vw
        +phone
          width: 5%
          margin-right: 6vw
      .secPage
        font-size: 0.8vw
        margin-right: 0.5vw
        color: #878787
        cursor: pointer
        +pad
          font-size: 1.8vw
          margin-right: 1.8vw
        +phone
          // width: 5%
          margin-right: 6vw
          font-size: 4vw


        &.active
          color: black
      .secDot
        font-size: 0.8vw
        color: #878787
        margin-right: 0.5vw
        +pad
          font-size: 1.8vw
          margin-right: 1.8vw
        +phone
          width: 5%
          margin-right: 3.5vw

      .secFinal
        font-size: 0.8vw
        margin-right: 0.5vw
        color: #878787
        cursor: pointer
        +pad
          font-size: 1.8vw
          margin-right: 1.8vw
        +phone
          width: 5%
          margin-right: 3.5vw
          font-size: 3.5vw

      .secNext
        width: 1%
        height: 40%
        background: url('../../assets/slide/next.png')
        +bgcon
        // +bb
        background-position: 0 0
        background-size: 100% auto
        opacity: 0.5
        margin-top: 0.1%
        cursor: pointer
        +pad
          width: 3%
          height: 100%
        +phone
          width: 5%
.active
  transition: 0.3s !important
  opacity: 1 !important
  visibility: visible !important
.selected
  transform: rotate(-45deg) !important
  transition: 0.3s !important

</style>



// WEBPACK FOOTER //
// src/views/Section/Section.vue